import React from 'react';
import cn from 'classnames';

import Card from '../Card/Card';

import classes from './TitleCard.module.scss';
import Props from './TitleCard.props';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TitleCard = ({
  title,
  icon,
  children,
  size = 'md',
  titleStyle = 'HalfWidth',
  className,
}: Props) => {
  return (
    <Card hasBackground className={className}>
      <div className={cn(classes.TitleCard, classes[size])}>
        <p className={cn(classes.Title, classes[titleStyle])}>
          {!!icon && <FontAwesomeIcon icon={icon} />}
          {title}
        </p>
        <div className={classes.Content}>{children}</div>
      </div>
    </Card>
  );
};

export default TitleCard;
